import React from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";

import DefaultPanelLayout from "components/items/default-panel-layout";
import getCandidateDiseaseStateDescription from "app/main/candidates/helpers/get-candidate-disease-state-description";
import TextLink from "components/items/text-link";
import { CareSummaryIcon } from "helpers/icon-finder";
import DefaultItem from "components/items/default-item";

const renderCandidateDiseaseState = (diseaseStateType, diseaseState) => {
  const isPrimary = diseaseState === "Primary";
  const indicator = isPrimary ? " (P)" : " (S)";
  return (
    <TextLink
      className={clsx("mr-8")}
      content={`${getCandidateDiseaseStateDescription(diseaseStateType)}${indicator}`}
    />
  );
};

const DiseaseState = ({ candidate }) => {
  if (isEmpty(candidate)
    || (isEmpty(candidate.ihd) && isEmpty(candidate.hf) && isEmpty(candidate.dm) && isEmpty(candidate.copd))
  ) {
    return <TextLink content="None Recorded" />;
  }

  return (
    <div className="flex-row-container enable-shrink">
      {!isEmpty(candidate.ihd) && renderCandidateDiseaseState("IHD", candidate.ihd)}
      {!isEmpty(candidate.hf) && renderCandidateDiseaseState("HF", candidate.hf)}
      {!isEmpty(candidate.dm) && renderCandidateDiseaseState("DM", candidate.dm)}
      {!isEmpty(candidate.copd) && renderCandidateDiseaseState("COPD", candidate.copd)}
    </div>
  );
};

const CareSummaryPanel = ({ candidate }) => (
  <DefaultPanelLayout
    title="Care Summary"
    icon={<CareSummaryIcon />}
  >
    <DefaultItem
      label="DISEASE STATE"
      content={<DiseaseState candidate={candidate} />}
      labelClassName="w-192"
    />
  </DefaultPanelLayout>
);

export default CareSummaryPanel;
